import React, { useEffect, useRef, useState } from "react";
import Collapsible from "react-collapsible";
import { Link, NavLink, useHistory } from "react-router-dom";
import "./Menu.scss";
import {
    menuList,
    modules,
    settingsMenu,
    menuLinks,
    // smrWithSettings,
    // smrWithoutSettings,
    subscriptionSettings,
    // smrWithSettingswithoutAnalytics,
    smrLists,
    // smrWithSettingswithoutFilters,
    // publishingWithSettings,
    // publishingWithoutSettings,
    // gettingStartedLists,
    subscriptionSettingsWithPlansOnly,
    opaWithoutYT,
    userSettings,
} from "./menuUtils";

// Menu Icons
import { ReactComponent as adminpanel } from "../../../assets/svg/adminpanel.svg";
import { ReactComponent as video } from "../../../assets/svg/video-tutorials.svg";
import { ReactComponent as alert } from "../../../assets/svg/alert.svg";
import { ReactComponent as collection } from "../../../assets/svg/collection.svg";
import { ReactComponent as dashboard } from "../../../assets/svg/dashboard.svg";
import { ReactComponent as datausage } from "../../../assets/svg/datausage-old.svg";
import { ReactComponent as ownedpageanalytics } from "../../../assets/svg/ownedpageanalytics.svg";
import { ReactComponent as facebookInsights } from "../../../assets/svg/facebook-insight.svg";
import { ReactComponent as opaOverview } from "../../../assets/svg/opa-overview.svg";
import { ReactComponent as query } from "../../../assets/svg/query.svg";
import { ReactComponent as report } from "../../../assets/svg/report.svg";
import { ReactComponent as socialtokens } from "../../../assets/svg/socialtokens.svg";
import { ReactComponent as trend } from "../../../assets/svg/trend.svg";
import { ReactComponent as usermanagement } from "../../../assets/svg/usermanagement.svg";
import { ReactComponent as privateviews } from "../../../assets/svg/privateviews.svg";
import { ReactComponent as publicviews } from "../../../assets/svg/publicviews.svg";
import { ReactComponent as teamviews } from "../../../assets/svg/teamviews.svg";
import { ReactComponent as systemviews } from "../../../assets/svg/systemviews.svg";
import { ReactComponent as search } from "../../../assets/svg/search.svg";
import { ReactComponent as scanner } from "../../../assets/svg/scanner.svg";
import { ReactComponent as downloads } from "../../../assets/svg/downloads.svg";
import { ReactComponent as settings } from "../../../assets/svg/settings.svg";
import { ReactComponent as commandCenter } from "../../../assets/svg/command-center.svg";
import { ReactComponent as Chevron } from "../../../assets/svg/chevron.svg";
import { ReactComponent as data } from "../../../assets/svg/querybuilder.svg";
import { ReactComponent as privacypolicy } from "../../../assets/svg/privacypolicy.svg";
import { ReactComponent as research } from "../../../assets/svg/research.svg";
import { ReactComponent as ErrImage } from "../../../assets/svg/radarr-logo.svg";
import { ReactComponent as smr } from "../../../assets/svg/smr-icon.svg";
import { ReactComponent as smp } from "../../../assets/svg/smp-icon.svg";
import { ReactComponent as subscription } from "../../../assets/svg/subscription-icon.svg";
import { ReactComponent as home } from "../../../assets/svg/Home.svg";
import { ReactComponent as CompanyLogo } from "../../../assets/radarr-logo.svg";
// import { ReactComponent as ModuleSwitcher } from "../../../assets/svg/module-switcher.svg";
import { ReactComponent as ModuleSwitcher } from "../../../assets/svg/modules/module-switch.svg";
// import { ReactComponent as listening } from "../../../assets/svg/modules/listening.svg";
import { ReactComponent as listening } from "../../../assets/svg/modules/new-listen.svg";
// import { ReactComponent as pageAnalytics } from "../../../assets/svg/modules/page-analytics.svg";
import { ReactComponent as pageAnalytics } from "../../../assets/svg/modules/new-page-analytics.svg";
// import { ReactComponent as publish } from "../../../assets/svg/modules/publish.svg";
import { ReactComponent as publish } from "../../../assets/svg/modules/new-publish.svg";
// import { ReactComponent as response } from "../../../assets/svg/modules/response.svg";
import { ReactComponent as response } from "../../../assets/svg/modules/new-response.svg";
// import { ReactComponent as commandCenter } from "../../../assets/svg/modules/response.svg";
import ModuleToggle from "../../../assets/svg/modules/toggle-module.svg";
import { ReactComponent as RadarrIcon } from "../../../assets/svg/radarr-icon.svg";
import { gettingStartedProgress } from "../../../actions/globalAction";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModule } from "../../../actions/sideBarActions";
import { ReactComponent as facebookIcon } from "../../../assets/svg/facebook-icon.svg";
import { ReactComponent as twitterIcon } from "../../../assets/svg/twitter-logo.svg";
import { ReactComponent as instagramIcon } from "../../../assets/svg/instagram.svg";
import { ReactComponent as cannedResponse } from "../../../assets/svg/canned-response-icon.svg";
import { ReactComponent as assetLibrary } from "../../../assets/svg/asset-library.svg";
import { ReactComponent as filterIcon } from "../../../assets/svg/filter-white.svg";
import { ReactComponent as linkedinIcon } from "../../../assets/svg/linkedin.svg";
import { ReactComponent as youtubeIcon } from "../../../assets/svg/youtube-icon.svg";
import { ReactComponent as integrationIcon } from "../../../assets/svg/integration.svg";
import { ReactComponent as tiktokIcon } from "../../../assets/svg/tiktok-icon.svg";
import { ReactComponent as smpCreateNew } from "../../../assets/svg/create-new.svg";
import { ReactComponent as surveyIcon } from "../../../assets/svg/survey.svg";
import UseGAEventsTracker from "../../hooks/UseGAEventsTracker";
import { allowedCompanies } from "./companyAccessToSf";

const menuIcons = {
    response,
    publish,
    pageAnalytics,
    listening,
    commandCenter,

    facebookIcon,
    twitterIcon,
    instagramIcon,
    adminpanel,
    alert,
    home,
    collection,
    dashboard,
    datausage,
    ownedpageanalytics,
    query,
    report,
    socialtokens,
    trend,
    usermanagement,
    privateviews,
    publicviews,
    teamviews,
    systemviews,
    search,
    scanner,
    downloads,
    video,
    // empty,
    facebookInsights,
    settings,
    // commandcenter,
    data,
    privacypolicy,
    research,
    smr,
    smp,
    subscription,
    cannedResponse,
    assetLibrary,
    integrationIcon,
    filterIcon,
    linkedinIcon,
    tiktokIcon,
    youtubeIcon,
    smpCreateNew,
    surveyIcon,
    opaOverview,
};
const Menu = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const GAEventsTracker = UseGAEventsTracker("Sidebar Menu event");
    const { pathname, company, packageObj, teams, sidebarExpanded, sidebarToggle, command_center, user } = props;

    const progressFields = useSelector((state) => state.globalReducer.progressFields);
    // const packageObj = useSelector((state) => state.globalReducer.packageObj);
    // const showGettingStarted = useSelector((state) => state.globalReducer.showGettingStarted);
    const activeModule = useSelector((state) => state.sidebarReducer.activeModule);

    const tokenProviderType = user?.roles?.length === 1 && user?.roles?.includes("token_provider");

    const [levels, setLevels] = useState({ level1: "", level2: "" });
    const [isError, setIsError] = useState(false);
    const [toggleModulePopup, setToggleModulePopup] = useState(false);
    // const isCommandCenterEnabled = command_center && command_center.enabled;
    const isCommandCenterEnabled = false;

    const moduleSwitcherTab = useRef(null);

    useEffect(() => {
        const module = localStorage.getItem("activeModule");
        dispatch(setActiveModule(module));
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (moduleSwitcherTab.current && !moduleSwitcherTab.current.contains(event.target)) {
                setToggleModulePopup(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [moduleSwitcherTab]);

    useEffect(() => {
        updateSidebarHighlights();
    }, [pathname]);

    useEffect(() => {
        // updateSidebarHighlights();
        setIsError(false);
    }, [company.company_logo_v2]);

    const updateSidebarHighlights = () => {
        let pathvals = pathname.split("/");

        if (menuLinks.includes(pathvals[1])) {
            if (["facebook-tokens", "instagram-tokens"].includes(pathvals[1])) {
                setLevels({ level1: "ADD SOCIAL TOKENS", level2: "" });
            } else if (["settings"].includes(pathvals[1])) {
                setLevels({ level1: "SETTINGS", level2: "" });
            } else if (["twitter-trends", "youtube-trends"].includes(pathvals[1])) {
                setLevels({ level1: "TRENDS", level2: "" });
            } else if (["dashboard"].includes(pathvals[1])) {
                setLevels({ level1: "Dashboard", level2: "" });
            } else if (["billing"].includes(pathvals[1]) && !["history"].includes(pathvals[1])) {
                setLevels({ level1: "Subscription", level2: "" });
            } else if (["social-response"].includes(pathvals[1])) {
                setLevels({ level1: "Social Media Response", level2: "" });
            }
        } else {
            setLevels({ level1: "", level2: "" });
        }
    };

    const onError = () => {
        setIsError(true);
    };

    const toTitleCase = (str) => {
        if (str === "YouTube Trends") return "YouTube Trends";
        else if (str === "SMR Settings") return "SMR Settings";
        else if (str === "SMR Survey") return "SMR Survey";
        else if (str === "SMR Dashboard") return "SMR Dashboard";
        else if (str === "SMR Reports") return "SMR Reports";
        else if (str === "SMR Inbox") return "SMR Inbox";
        else if (str === "SMR Canned Response") return "SMR Canned Response";
        else if (str === "SMP Dashboard") return "SMP Dashboard";
        else if (str === "SMP Settings") return "SMP Settings";

        if (str === "SMR Filters") return "SMR Filters";
        if (str === "Integrations") return "Integrations";
        if (str === "LINKEDIN INSIGHTS") return "LinkedIn Insights";
        if (str === "TIKTOK INSIGHTS") return "TikTok Insights";
        if (str === "YOUTUBE INSIGHTS") return "YouTube Insights";
        if (str === "SMBDashboard") return "Dashboard";
        if (str === "SMB Query Builder") return "Query Builder";
        if (str === "OPA OVERVIEW") return "Overview";
        if (str === "Publishing") return "Publishing (Beta)";
        if (str === "Page Analytics" || str == "PAGE ANALYTICS") return "Page Analytics (Beta)";
        if (str === "Listening New") return "Listening";

        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    function getItem(item, level = 1) {
        let tour_className = "";
        if (item.name == "TRENDS") tour_className = "trends_step1";
        if (item.name == "X Trends") tour_className = "trends_step2";
        if (item.name == "YouTube Trends") tour_className = "trends_step3";
        if (item.name == "Dashboard") tour_className = "dashboard_step1";
        if (item.name == "All Dashboards") tour_className = "dashboard_step2";
        if (item.name == "Standard Dashboards") tour_className = "dashboard_step3";
        if (item.name == "My Dashboards") tour_className = "dashboard_step4";
        if (item.name == "Shared Dashboards") tour_className = "dashboard_step5";
        if (item.name == "Favorites") tour_className = "dashboard_step6";
        if (item.name == "Trash") tour_className = "dashboard_stepTrash";
        if (item.name == "REPORTS") tour_className = "reports_step1";
        if (item.name == "ALERTS") tour_className = "alerts_step1";
        if (item.name == "COLLECTIONS") tour_className = "collection_step0";
        if (item.name == "FACEBOOK") tour_className = "fbInsights_step0";
        if (item.name == "DOWNLOADS") tour_className = "downloads_step0";
        if (item.name == "Search") tour_className = "search_step0";
        if (item.name == "DATA USAGE") tour_className = "dataUsage_step0";
        if (item.name == "Overview") tour_className = "dataUsage_step1";
        if (item.name == "Analytics") tour_className = "dataUsage_step2";
        if (item.name == "ADD SOCIAL TOKENS") tour_className = "fbTokens_step0";
        if (item.name == "Facebook Tokens") tour_className = "fbTokens_step1";
        if (item.name == "Instagram Tokens") tour_className = "igTokens_step1";
        if (item.name == "BLOCK SOURCE") tour_className = "blockSource_step0";
        if (item.name == "FILTERS") tour_className = "filters_step1";
        if (item.name == "WORDCLOUD") tour_className = "wordCloud_step1";
        if (item.name == "USER MANAGEMENT") tour_className = "userManagement_step1";
        if (item.name == "ACTIVITY LOGS") tour_className = "activityLogs_step1";
        if (item.name == "LOGIN LOGS") tour_className = "loginLogs_step0";
        if (item.name == "Logo") tour_className = "logo_step0";
        if (item.name == "Social Media Response") tour_className = "smr_step0";
        if (item.name == "SMR Settings") tour_className = "smr_step1";
        if (item.name == "Smart Inbox" || item.name == "Social Media Response") tour_className = "smr_step11";
        if (item.name == "SMR Analytics") tour_className = "smr_step14";
        // if (item.name == "Query Builder") tour_className = "qb_step1";
        if (item.name == "SMP Dashboard") tour_className = "smp_step1";
        if (item.name == "SMP Settings") tour_className = "smp_step2";
        if (item.name == "Asset Library") tour_className = "smp_step3";
        if (item.name == "COMPETITOR INSIGHTS") tour_className = "competitor_step1";

        let percentage = "";
        if (item.name == "Getting Started") {
            let percent = 0;

            let total_fields = 34;
            percent = Math.round((progressFields?.sections?.length / total_fields) * 100);
            percentage = `(${percent}%)`;
        }

        if (item.subItems) {
            let IconComponent = menuIcons[item.icon];
            return (
                <Collapsible
                    open={sidebarExpanded && ((level === 1 && levels.level1 === item.name) || (level === 2 && levels.level2 === item.name))}
                    key={item.name}
                    id={item.name}
                    transitionTime={200}
                    handleTriggerClick={() => handleCollapsibleClick({ ...item, level })}
                    className={`level-${level} bg-${activeModule}`}
                    openedClassName={`level-${level}`}
                    trigger={
                        <div title={item.name} className={`collapsible-item bg-${activeModule}`} id={`collapsible-item ${item.name}`}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (IconComponent ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">{toTitleCase(item.name)}</span>
                            </span>
                            <Chevron className={`chevron-collapsible bg__icon-${activeModule}`} />
                        </div>
                    }>
                    {sidebarExpanded && item.subItems.map((si) => getItem(si, level + 1))}
                </Collapsible>
            );
        } else {
            if (Object.prototype.hasOwnProperty.call(item, "type") && item.type === "react") {
                let IconComponent = menuIcons[item.icon];
                if (item.packageFeature && !item.packageFeature.includes(packageObj.package_code)) {
                    return;
                }
                return (
                    <NavLink
                        key={item.name + level}
                        style={{ textDecorationLine: "none", textDecoration: "none" }}
                        to={item.Link}
                        activeClassName="active"
                        onClick={() => handleLinkClick({ ...item, level })}>
                        <div
                            key={item.name}
                            title={item.name}
                            className={`menulink level-${level} bg-${activeModule}  ${
                                item.name.toLowerCase() === "custom dashboard" ? "custom-dashboard" : item.name.toLowerCase()
                            } `}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (item.icon ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">
                                    {toTitleCase(item.name)} {percentage}
                                </span>
                            </span>
                        </div>
                    </NavLink>
                );
            } else {
                let IconComponent = menuIcons[item.icon];
                return (
                    <a style={{ textDecorationLine: "none", textDecoration: "none" }} href={gotoLink(item.Link)} target={item.target ? item.target : "_self"}>
                        <div key={item.name} title={item.name} className={`menulink level-${level} `} onClick={() => gotoLink(item.Link)}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (item.icon ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">{toTitleCase(item.name)}</span>
                            </span>
                        </div>
                    </a>
                );
            }
        }
    }
    function getCommonContent() {
        let menu = [];
        let percent = 0;
        if (user.roles.includes("admin") || user.roles.includes("cxm") || user.roles.includes("companyadmin") || user.roles.includes("cxa")) {
            if (user.roles.includes("admin") || user.roles.includes("cxm") || user.roles.includes("companyadmin")) {
                if (packageObj?.features?.owned_page_analytics.quota == 0) percent = Math.round((progressFields?.sections?.length / 10) * 100);
                else percent = Math.round((progressFields?.sections?.length / 11) * 100);
            } else {
                if (packageObj?.features?.owned_page_analytics.quota == 0) percent = Math.round((progressFields?.sections?.length / 9) * 100);
                else percent = Math.round((progressFields?.sections?.length / 10) * 100);
            }
        } else {
            if (packageObj?.features?.owned_page_analytics.quota == 0) percent = Math.round((progressFields?.sections?.length / 8) * 100);
            else percent = Math.round((progressFields?.sections?.length / 9) * 100);
        }

        // if (showGettingStarted && percent !== 100)
        menu.push(getItem(menuList.find((m) => m.name === "Getting Started")));
        menu.push(getItem(menuList.find((m) => m.name === "Tutorials")));
        return menu;
    }

    function getBlockOne() {
        let menu = [];
        let enableFiltersAndIntegrations = allowedCompanies.includes(company.company_lite_company_id);

        if (
            pathname.split("/").includes("home") ||
            pathname.split("/").includes("completed") ||
            pathname.split("/").includes("gettingStarted") ||
            // pathname.split("/").includes("tutorials") ||
            !activeModule
        ) {
            dispatch(setActiveModule(null));
            // let rolesAssigned = ["admin", "cxm", "companyadmin", "cxa"];
            // let smpRolesincluded = ["companyadmin", "admin", "smp_manager", "smp_agent"];

            if (packageObj?.features?.listening_module_access?.quota) menu.push(getItem(menuList.find((m) => m.name === "Listening")));
            else menu.push(getItem(menuList.find((m) => m.name === "Listening New")));

            if (
                packageObj?.features?.smr_module_access?.quota
                //  && responseRolesRequired.some((role) => user.roles.includes(role))
            )
                menu.push(getItem(menuList.find((m) => m.name === "Response")));
            if (packageObj?.features?.opa_module_access?.quota) menu.push(getItem(menuList.find((m) => m.name === "Page Analytics")));
            if (
                packageObj?.features?.smp_module_access?.quota
                // && publishRolesRequired.some((role) => user?.roles.includes(role))
            )
                menu.push(getItem(menuList.find((m) => m.name === "Publishing")));
            // isCommandCenterEnabled &&
            // menu.push(getItem({ name: "Command Center", Link: "https://commandcenter.circussocial.com/", target: "_blank", icon: "commandCenter" }, 1));
            return menu;
        }

        switch (activeModule) {
            case "Listening":
                if (packageObj?.features?.listening_module_access?.quota == 1) {
                    if (packageObj.package_code !== "enterprise") menu.push(getItem(menuList.find((m) => m.name === "SMB Query Builder")));
                    else menu.push(getItem(menuList.find((m) => m?.key === "Query Builder")));
                    if (packageObj.package_code !== "enterprise") menu.push(getItem(menuList.find((m) => m.name === "SMBDashboard")));
                    else menu.push(getItem(menuList.find((m) => m.name === "Dashboard")));
                    menu.push(getItem(menuList.find((m) => m.name === "REPORTS")));
                    menu.push(getItem(menuList.find((m) => m.name === "ALERTS")));
                    if (packageObj.package_code === "enterprise") menu.push(getItem(menuList.find((m) => m.name === "COLLECTIONS")));
                    if (packageObj.package_code === "enterprise") menu.push(getItem(menuList.find((m) => m.name === "TRENDS")));
                    menu.push(getItem(menuList.find((m) => m.name === "DOWNLOADS")));
                    if (packageObj.package_code === "enterprise") menu.push(getItem(menuList.find((m) => m.name === "Search")));
                    if (!tokenProviderType && packageObj?.package_code === "enterprise") menu.push(getItem(menuList.find((m) => m.name === "DATA USAGE")));
                    // if (packageObj.package_code === "smb" && !tokenProviderType && adminType) menu.push(getItem(SMBsettingsMenu));

                    if (!tokenProviderType && adminType) menu.push(getItem(settingsMenu));
                } else {
                    menu.push(getItem(menuList.find((m) => m.name === "DOWNLOADS")));
                    if (!tokenProviderType && adminType) menu.push(getItem(userSettings));
                }

                break;

            case "Page Analytics":
                // if (packageObj?.features?.owned_page_analytics.quota > 0) menu.push(getItem(menuList.find((m) => m.name === "PAGE ANALYTICS")));
                if (packageObj?.features?.owned_page_analytics.quota > 0) {
                    menu.push(getItem(menuList.find((m) => m.name === "OPA OVERVIEW")));
                    menu.push(getItem(menuList.find((m) => m.name === "FACEBOOK INSIGHTS")));
                    menu.push(getItem(menuList.find((m) => m.name === "INSTAGRAM INSIGHTS")));
                    menu.push(getItem(menuList.find((m) => m.name === "X INSIGHTS"))); //Changed Twitter name to X
                    menu.push(getItem(menuList.find((m) => m.name === "LINKEDIN INSIGHTS")));
                    menu.push(getItem(menuList.find((m) => m.name === "TIKTOK INSIGHTS")));
                    if (packageObj?.features?.youtube_opa?.quota) menu.push(getItem(menuList.find((m) => m.name === "YOUTUBE INSIGHTS")));
                    menu.push(getItem(menuList.find((m) => m.name === "COMPETITOR INSIGHTS")));
                }
                break;

            case "Publishing":
                if (publishRolesRequired.some((role) => user?.roles.includes(role))) {
                    if (["smp_manager", "companyadmin", "admin"].some((role) => user?.roles.includes(role))) {
                        menu.push(getItem(menuList.find((m) => m.name === "SMP Settings")));
                        // menu.push(getItem(menuList.find((m) => m.name === "SMP Analytics")));
                    }

                    menu.push(getItem(menuList.find((m) => m.name === "Asset Library")));
                    menu.push(getItem(menuList.find((m) => m.name === "Create New")));
                    if (["admin", "companyadmin", "smp_manager"].some((role) => user?.roles.includes(role)))
                        menu.push(getItem(menuList.find((m) => m.name === "SMP Dashboard")));
                }
                break;

            case "Response":
                if (
                    // user.roles.includes("admin") || user.roles.includes("cxm") || user.roles.includes("companyadmin") || user.roles.includes("cxa")
                    responseRolesRequired.some((role) => user?.roles.includes(role))
                ) {
                    if (user.roles.includes("companyadmin") || user.roles.includes("admin") || user.roles.includes("cxm")) {
                        menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Settings")));
                        menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Inbox")));
                        menu.push(getItem(smrLists.find((obj) => obj.name === "Keyword Based Sync")));

                        if (user.roles.includes("cxm")) {
                            // enableFiltersAndIntegrations && menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Filters")));
                            menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Dashboard")));
                            // menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Canned Response")));
                            // enableFiltersAndIntegrations && menu.push(getItem(smrLists.find((obj) => obj.name === "Integrations")));
                        }
                        if (user.roles.includes("companyadmin") || user.roles.includes("admin") || user.roles.includes("cxm")) {
                            menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Reports")));
                        }
                        // menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Survey")));
                        // else condition // menu.push(getItem(smrWithSettingswithoutAnalytics));
                    } else {
                        menu.push(getItem(smrLists.find((obj) => obj.name === "SMR Inbox")));
                    }
                }
                // }
                break;

            default:
                break;
        }

        return menu;
    }

    const getBlockThree = () => {
        let menu = [];
        switch (activeModule) {
            case "Listening":
                // if (packageObj?.features?.owned_page_analytics.quota > 0) menu.push(getItem(menuList.find((m) => m.name === "PAGE ANALYTICS")));
                menu.push(getItem(menuList.find((m) => m.name === "SOCIAL TOKENS")));
                break;

            case "Publishing":
                if (packageObj?.features?.owned_page_analytics.quota > 0) {
                    if (packageObj?.features?.youtube_opa?.quota) menu.push(getItem(menuList.find((m) => m.name === "PAGE ANALYTICS")));
                    else {
                        menu.push(getItem(opaWithoutYT));
                    }
                }
                break;

            case "Page Analytics":
                menu.push(getItem(menuList.find((m) => m.name === "SOCIAL TOKENS")));
                break;
            // case "Response":
            //     menu.push(getItem(menuList.find((m) => m.name === "PAGE ANALYTICS")));
            //     break;

            default:
                break;
        }
        if (!tokenProviderType && packageObj?.package_code !== "enterprise") {
            packageObj?.package_code === "free" ? menu.push(getItem(subscriptionSettingsWithPlansOnly)) : menu.push(getItem(subscriptionSettings));
        }

        return menu;
    };

    const switchModule = (e) => {
        setToggleModulePopup(false);
        const newModule = e.target.id;
        if (newModule !== "Command Center") {
            if (
                newModule === "Listening" ||
                newModule === "Page Analytics" ||
                (newModule === "Publishing" && publishRolesRequired.some((role) => user?.roles.includes(role))) ||
                (newModule === "Response" && responseRolesRequired.some((role) => user?.roles.includes(role)))
            ) {
                localStorage.setItem("activeModule", newModule);
                dispatch(setActiveModule(newModule));
                GAEventsTracker("Module clicked", newModule);
            }
            switch (newModule) {
                case "Listening":
                    if (packageObj?.features?.listening_module_access?.quota == 1) history.push("/dashboard/all");
                    else history.push("/downloads");
                    break;

                case "Page Analytics":
                    history.push("/owned-page");
                    break;

                case "Publishing":
                    history.push("/social-media-publishing/create-post");
                    break;

                case "Response":
                    history.push("/social-response/inbox");
                    break;
                default:
                    break;
            }
        }
        // else {
        //     const link = "https://commandcenter.circussocial.com/";
        //     window.open(link, "_blank");
        // }
    };

    const moduleSwitcherContent = () => {
        let ModuleIcon = null;
        let modulesEnabled = [];

        //arr[0]= moduleName, arr[1]= icon
        // if (packageObj?.features?.listening_module_access?.quota)
        modulesEnabled.push(["Listening", "listening"]);

        if (
            packageObj?.features?.smr_module_access?.quota
            //  && responseRolesRequired.some((role) => user.roles.includes(role))
        )
            modulesEnabled.push(["Response", "response"]);
        if (packageObj?.features?.opa_module_access?.quota) modulesEnabled.push(["Page Analytics", "pageAnalytics"]);
        if (
            packageObj?.features?.smp_module_access?.quota
            //  &&publishRolesRequired.some((role) => user?.roles.includes(role))
        )
            modulesEnabled.push(["Publishing", "publish"]);
        // modulesEnabled.push(["Command Center", "commandCenter"]);

        return (
            <>
                <div ref={moduleSwitcherTab} className="popup__content skiptranslate ">
                    <Link to="/home" className="popup__home__module">
                        <div
                            onClick={() => {
                                dispatch(setActiveModule(null));
                            }}
                            className="radarr__heading">
                            <RadarrIcon />
                            <div className="module__name">Modules</div>
                        </div>
                    </Link>

                    {modulesEnabled.map(([moduleName, icon], idx) => {
                        ModuleIcon = menuIcons[icon];
                        let hideModule = false;
                        if (moduleName === "Command Center") hideModule = !isCommandCenterEnabled;
                        return (
                            <div
                                onClick={switchModule}
                                id={moduleName}
                                className={`individual__modules bg-${activeModule} ${moduleName} ${moduleName === activeModule ? "active" : ""} ${
                                    hideModule && "hide__module"
                                }`}
                                key={idx}>
                                <ModuleIcon id={moduleName} />
                                <div className="module__name" id={moduleName}>
                                    {["Publishing", "Page Analytics"].includes(moduleName) ? `${moduleName} (Beta)` : moduleName}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    function handleLinkClick(item) {
        if (item.name == "Getting Started") dispatch(gettingStartedProgress());

        if (
            // pathname.split("/").includes("home")
            // || pathname.split("/").includes("gettingStarted") &&
            item.name === "Listening" ||
            item.name === "Page Analytics" ||
            // item.name === "Publishing" ||
            // item.name === "Response"
            (item.name === "Publishing" && publishRolesRequired.some((role) => user?.roles.includes(role))) ||
            (item.name === "Response" && responseRolesRequired.some((role) => user?.roles.includes(role)))
        ) {
            localStorage.setItem("activeModule", item.name);
            dispatch(setActiveModule(item.name));

            GAEventsTracker("Module clicked", item.name);
        } else {
            // const module = localStorage.getItem("activeModule");
            // GAEventsTracker("Menu Option clicked", `${module}-${item.name}`);
            GAEventsTracker("Menu option clicked", `${item.name}`);
        }

        if (item.level === 1) setLevels({ level1: "", level2: "" });

        if (
            item.name == "All Dashboards" ||
            item.name == "Standard Dashboards" ||
            item.name == "My Dashboards" ||
            item.name == "Shared Dashboards" ||
            item.name == "Favorites"
        ) {
            localStorage.removeItem("tour_createDashboard"); //to restart dashboard tour
        }
    }

    function gotoLink(link) {
        if (link) {
            if (process.env.NODE_ENV === "development") {
                if (link.indexOf("unified/") > -1) return link.split("unified/")[1];
                return link;
            } else if (link.indexOf("https://") > -1) return link;
            else return `/${link}`;
        }
    }

    function handleCollapsibleClick(item) {
        if (!sidebarExpanded) sidebarToggle();
        else if (item.name === levels.level1 || item.name === levels.level2) {
            return setLevels({ level1: "", level2: "" });
        }

        if (item.level === 1) {
            setLevels({ level1: item.name });
        }

        if (item.level === 2) {
            setLevels({
                level1:
                    item.view_type === "system"
                        ? "SYSTEM VIEWS"
                        : parseInt(item.access_type) === 0
                        ? "PRIVATE VIEWS"
                        : parseInt(item.access_type) === 1
                        ? "PUBLIC VIEWS"
                        : "TEAM VIEWS",
                level2: item.name,
            });
        }
    }

    const moduleNameWithIcon = () => {
        // if (!activeModule) {
        return (
            <>
                <div className={`sidebar__module__name__when__expanded  ${activeModule === "Page Analytics" ? "full__wdith" : ""} `}>
                    <div className="module__name__div">
                        {activeModule ? (["Publishing", "Page Analytics"].includes(activeModule) ? `${activeModule} (Beta)` : activeModule) : "Select Module"}
                    </div>
                    {/* <ModuleToggle className=" module__toggle__icon" /> */}
                    <img src={ModuleToggle} alt="" className=" module__toggle__icon" />
                </div>
            </>
        );
        // }

        // const [[moduleName, icon]] = modules.filter(([name, icon]) => name === activeModule);
        // const ModuleIcon = menuIcons[icon];

        // return (
        //     <>
        //         <div className={`sidebar__module__name__when__expanded ${moduleName}`}>
        //             <ModuleIcon />
        //             <div>{moduleName}</div>
        //             <img src={ModuleToggle} alt="" className=" module__toggle__icon" />
        //             {/* <ModuleToggle className=" module__toggle__icon" /> */}
        //         </div>
        //     </>
        // );
    };

    const moduleIcon = () => {
        const [[moduleName, icon]] = modules.filter(([name, icon]) => name === activeModule);
        const ModuleIcon = menuIcons[icon];
        return <ModuleIcon className={`large__${icon}`} />;
    };

    const sidebarModuleIcon = () => {
        if (activeModule) {
            const [[moduleName, icon]] = modules.filter(([name, icon]) => name === activeModule);
            const ModuleIcon = menuIcons[icon];
            return (
                <div className={`svg__icon ${activeModule}`}>
                    <ModuleIcon />;
                </div>
            );
        }
    };
    let companyLogo = props.company.company_logo_v2;
    let adminType = user?.roles?.includes("admin") || user?.roles.includes("companyadmin");
    if (!companyLogo || !companyLogo.includes("https://")) companyLogo = props.company.company_logo;
    return (
        <div className="sidebar__menu">
            <div className="top__block">
                <div className="home_step5">
                    {getCommonContent()}
                    <div className={`sidebar-divider ${activeModule && activeModule}`}></div>
                    {!tokenProviderType && getBlockOne()}
                    {/* {getHomeBlock()} */}
                    {!tokenProviderType && <div className={`sidebar-divider ${activeModule && activeModule}`}></div>}

                    {/* {!pathname.split("/").includes("home") && ( */}
                    {/* <> */}
                    {getBlockThree()}
                    {/* {!tokenProviderType && adminType && getItem(settingsMenu)} */}
                    {/* {!tokenProviderType && packageObj?.package_code !== "enterprise" && packageObj?.package_code === "free"
                                ? getItem(subscriptionSettingsWithPlansOnly)
                                : getItem(subscriptionSettings)} */}
                    {/* {!this.tokenProviderType && command center*/}
                    {/* { (!tokenProviderType &&
                            packageObj?.package_code !== "enterprise" )(
                                packageObj?.package_code === "free"
                                ? getItem(subscriptionSettingsWithPlansOnly)
                                : getItem(subscriptionSettings))
                            
                            } */}
                    {/* </> */}
                    {/* )} */}
                </div>
            </div>
            <div className="bottom__block">
                <div className="module_switcher__wrapper">
                    <Popup
                        className={`module__popup ${sidebarExpanded ? "popup__sidebar__expanded" : "popup__sidebar__collpased"}`}
                        on="click"
                        hideOnScroll
                        open={toggleModulePopup}
                        content={moduleSwitcherContent()}
                        trigger={
                            <div
                                // ref={moduleSwitcherTab}
                                onClick={() => setToggleModulePopup((prev) => !prev)}
                                className={`${sidebarExpanded ? "module_switcher__container-expanded" : ""} module_switcher__container`}>
                                {activeModule ? moduleIcon() : <ModuleSwitcher />}
                                {!sidebarExpanded ? (
                                    <div className={`sidebar__module__name ${activeModule && activeModule}`}>
                                        {/* {activeModule ? <>{sidebarModuleIcon()}</> : <img src={ModuleToggle} alt="" className=" module__toggle__icon" />} */}
                                        <img src={ModuleToggle} alt="" className=" module__toggle__icon" />
                                    </div>
                                ) : (
                                    moduleNameWithIcon()
                                )}
                            </div>
                        }
                        inverted
                        size="mini"
                        position="right center"
                        style={{ zIndex: "99999" }}
                    />
                    {/* <CompanyLogo /> */}
                    {/* {props.sidebarExpanded && ( */}
                    <div className={`company-logo botom__client__logo ${!sidebarExpanded && "minimize__logo"}`}>
                        {!companyLogo ? <ErrImage /> : !isError ? <img src={companyLogo} className="company image" onError={onError} /> : <ErrImage />}
                    </div>
                    {/* )} */}
                    {/* // <img className="company__logo" src={CompanyLogo} alt="img" /> */}
                </div>
            </div>
        </div>
    );
};

export default Menu;
export const responseRolesRequired = ["admin", "cxm", "companyadmin", "cxa"];
export const publishRolesRequired = ["admin", "companyadmin", "smp_manager", "smp_agent"];
